<template>
  <div id="Lgx02728120758340918706823">
    <div class="flex gap-1 mb-1">
      <vs-button :color="selectedIoC === 0 ? 'primary' : 'grey'" type="filled" class="mb-2 mr-2" @click="selectedIoC = 0">IoC1</vs-button>
      <vs-button :color="selectedIoC === 1 ? 'primary' : 'grey'" type="filled" class="mb-2 mr-2" @click="selectedIoC = 1">IoC2</vs-button>
      <vs-button :color="selectedIoC === 2 ? 'primary' : 'grey'" type="filled" class="mb-2 mr-2" @click="selectedIoC = 2">IoC3</vs-button>
    </div>

    <div class="bg-dark p-3 main-border rounded-lg">
      <span class="terminal-line text-grey" style="line-height: 2rem" v-html="ioc[selectedIoC].content" />
    </div>

    <div class="bg-dark p-3 main-border rounded-lg flex gap-3 mt-6 sm:flex-col md:flex-row">
      <v-select
        class="sm:w-full md:w-1/2"
        placeholder="Select the analysis from the dropdown"
        :options="analysisOptions"
        v-model="ioc[selectedIoC].analysisValue"
        :class="{
          correct: ioc[selectedIoC].analysisCorrect,
          invalid: ioc[selectedIoC].analysisCorrect === false,
        }"
      />

      <v-select
        class="sm:w-full md:w-1/2"
        placeholder="Select the remediation from the dropdown"
        :options="remediationOptions"
        v-model="ioc[selectedIoC].remediationValue"
        :class="{
          correct: ioc[selectedIoC].remediationCorrect,
          invalid: ioc[selectedIoC].remediationCorrect === false,
        }"
      />
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import MovablePopup from '../../../../../../../../components/popup/MovablePopup';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      selectedIoC: 1,

      ioc: [
        {
          content: `
      Source Svc&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Type&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dest&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Data<br />
      Apache_httpd&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;DNSQ&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;@10.1.1.1:53&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;update.s.domain<br />
      Apache_httpd&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;DNSQR&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;@10.1.2.5&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;CNAME 3a129ak219r0slsmfkzzz000.a.domain<br />
      Apache_httpd&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;DNSQ&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;@10.1.1.1:53&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3a129ak219r0slsmfkzzz000.a.domain<br />
      Apache_httpd&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;DNSQR&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;@10.1.2.5&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;IN A 108.158.253.253<br />
      `,
          analysisAnswer: 'The service is attempting to resolve a malicious domain.',
          analysisValue: null,
          analysisCorrect: null,

          remediationAnswer: 'Implement a blocklist for known malicious ports.',
          remediationValue: null,
          remediationCorrect: null,
        },
        {
          content: `
      Src&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dst&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Proto&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Data&nbsp;&nbsp;&nbsp;&nbsp;Action<br />
      10.0.5.5&nbsp;&nbsp;&nbsp;&nbsp;10.1.2.1&nbsp;&nbsp;&nbsp;IP_ICMP&nbsp;&nbsp;&nbsp;&nbsp;ECHO&nbsp;&nbsp;&nbsp;&nbsp;Drop<br />
      10.0.5.5&nbsp;&nbsp;&nbsp;&nbsp;10.1.2.2&nbsp;&nbsp;&nbsp;IP_ICMP&nbsp;&nbsp;&nbsp;&nbsp;ECHO&nbsp;&nbsp;&nbsp;&nbsp;Drop<br />
      10.0.5.5&nbsp;&nbsp;&nbsp;&nbsp;10.1.2.3&nbsp;&nbsp;&nbsp;IP_ICMP&nbsp;&nbsp;&nbsp;&nbsp;ECHO&nbsp;&nbsp;&nbsp;&nbsp;Drop<br />
      10.0.5.5&nbsp;&nbsp;&nbsp;&nbsp;10.1.2.4&nbsp;&nbsp;&nbsp;IP_ICMP&nbsp;&nbsp;&nbsp;&nbsp;ECHO&nbsp;&nbsp;&nbsp;&nbsp;Drop<br />
      `,
          analysisAnswer: 'Someone is footprinting a network subnet.',
          analysisValue: null,
          analysisCorrect: null,

          remediationAnswer: 'Block ping requests across the WAN interface.',
          remediationValue: null,
          remediationCorrect: null,
        },
        {
          content: `
      Proxylog><br />
      > GET /announce?info_hash=%01d%FE%7E%F1%10%5CWvAp%ED%F6%03%C49%D6B%14%F1&<br />
      > peer_id=%B8js%7F%E8%0C%AFh%02Y%967%24e%27V%EEM%16%5B&port=41730&<br />
      > uploaded=0%downloaded=0%left=3767869%compact=1%ip=10.5.1.26&event=started<br />
      > HTTP/1.1<br />
      > Accept: application/x-bittorrent<br />
      > Accept-Encoding: gzip<br />
      > User-Agent: RAZA 2.1.0.0<br />
      > Host: localhost<br />
      > Connection: Keep-Alive<br />
      < <br />
      < HTTTP 200 OK
      `,
          analysisAnswer: 'An employee is using P2P services to download files.',
          analysisValue: null,
          analysisCorrect: null,

          remediationAnswer: 'Enforce endpoint controls on third-party software installations.',
          remediationValue: null,
          remediationCorrect: null,
        },
      ],

      analysisOptions: [
        'An employee is attempting to access a blocked website.',
        'Someone is footprinting a network subnet.',
        'An application is performing an automatic update.',
        'Canonical name records in a public DNS cache are being updated.',
        'Service identification and fingerprinting are occurring.',
        'The service is attempting to resolve a malicious domain.',
        'A host is participating in an IRC-based botnet.',
        'An employee is using P2P services to download files.',
      ],

      remediationOptions: [
        'Block ping requests across the WAN interface.',
        'Deploy a network-based DLP solution.',
        'Implement a blocklist for known malicious ports.',
        'Investigate for software supply-chain attacks.',
        'No further actions is needed.',
        'Configure the DNS server to perform recursion.',
        'Enforce endpoint controls on third-party software installations.',
      ],
    };
  },
  methods: {
    validatePassword(password) {
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d]).{8,}$/;
      return passwordRegex.test(password);
    },
    markSimulation() {
      let totalScore = 0;

      for (const iocItem of this.ioc) {
        if (iocItem.analysisValue === iocItem.analysisAnswer) {
          iocItem.analysisCorrect = true;
          totalScore++;
        } else {
          iocItem.analysisCorrect = false;
        }

        if (iocItem.remediationValue === iocItem.remediationAnswer) {
          iocItem.remediationCorrect = true;
          totalScore++;
        } else {
          iocItem.remediationCorrect = false;
        }
      }

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }
      this.$emit('simulation_getting_there', totalScore);
    },
  },
  components: {
    vSelect,
    MovablePopup,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss">
#Lgx02728120758340918706823 {
  .terminal-line {
    color: #f8f8f2;
    font-family: 'Fira Code', monospace;
    font-size: 0.875rem;
    line-height: 1.5;
    margin: 0.25rem 0;
  }

  .correct {
    border: 1px solid #31b952 !important;
    border-radius: 0.35rem;
  }

  .invalid {
    border: 1px solid #c93738 !important;
    border-radius: 0.35rem;
  }

  .vs-con-input {
    width: 100%;
  }
}
</style>
